import { render, staticRenderFns } from "./Tag3.vue?vue&type=template&id=7d08425e&scoped=true"
import script from "./Tag3.vue?vue&type=script&lang=js"
export * from "./Tag3.vue?vue&type=script&lang=js"
import style0 from "./Tag3.vue?vue&type=style&index=0&id=7d08425e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d08425e",
  null
  
)

export default component.exports